import { render, staticRenderFns } from "./blame_preferences.vue?vue&type=template&id=4ad80231"
import script from "./blame_preferences.vue?vue&type=script&lang=js"
export * from "./blame_preferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports